/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Tests_TitleInputs */

const en_validation_tests_title = /** @type {(inputs: Validation_Tests_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validation Tests`)
};

const nl_validation_tests_title = /** @type {(inputs: Validation_Tests_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validatietests`)
};

/**
* | output |
* | --- |
* | "Validation Tests" |
*
* @param {Validation_Tests_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const validation_tests_title = /** @type {((inputs?: Validation_Tests_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Tests_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_validation_tests_title(inputs)
	return en_validation_tests_title(inputs)
});